import { IExperienceContent } from '../../../types/core';

export default function getExperienceContent(): IExperienceContent[] {
	return [
		{
			company: "Epic",
			title: "MyChart Full Stack Software Developer",
			subTitle: "Epic Systems",
			link: {
				url: "https://www.epic.com/about",
				displayString: "Epic Systems"
			},
			icon: {
				path: "logos/epic-logo.png",
				alt: "Epic",
				url: "https://www.epic.com/about"
			},
			dateRange: {
				startDate: new Date("2021-05-10"),
				endDate: new Date()
			},
			location: "Rochester, Minnesota",
			descriptionList: [
				{
					text: "Owns projects from concept to release, partnering closely with UX, accessibility, and QA teams",
					subItems: [
						"Led a complete client-side rewrite of the questionnaires workflow from legacy JavaScript to React, coordinating a team that grew to 4 engineers, personally building some of its most complex interactive components, and ensuring compatibility across several other teams' products",
						"Developed a recommendation grouping engine to present dynamic patient care options intuitively",
						"Built guest-facing Self-Triage infrastructure, including unauthenticated patient access, upfront full-demographics capture, and a solo-delivered cross-deployment extension for Kaiser Permanente",
						"Introduced an accessible alternative to an inaccessible patient-data graphing framework"
					]
				},
				"Led technical and architectural decisions across cross-team initiatives, mentored developers, conducted code review, and served as the team's React resource and accessibility representative",
				"Engaged stakeholders across 25+ healthcare organizations through customer-facing meetings and an international webinar, gathering feedback, providing roadmap updates, and addressing concerns",
				"Drove project scoping, estimates, and timeline planning, and built an internal agentic AI-powered tool to automate code-review, design, and QA assignments across the team",
				"Ensured application quality, stability, and security by assessing impact and resolving functional issues and security vulnerabilities, with the team among the top performers in an org-wide remediation push",
				"Contributed more to the company-wide React SDK in 2025 than any other engineer, shipping reusable, accessible components like two-tier prompts, slider controls, and rich-media choice groups"
			]
		},
		{
			company: "Magenic",
			title: "Associate Consultant II",
			subTitle: "Magenic (Cognizant Softvision)",
			link: {
				url: "https://www.cognizantsoftvision.com/about-us/",
				displayString: "Magenic (Cognizant Softvision)"
			},
			icon: {
				path: "logos/magenic-logo.png",
				alt: "Magenic",
				url: "https://www.cognizantsoftvision.com/about-us/"
			},
			dateRange: {
				startDate: new Date("2019-10-14"),
				endDate: new Date("2021-03-19")
			},
			location: "St. Louis Park, Minnesota",
			descriptionList: [
				"Developed a Java/Spring microservice for loading, merging, and querying custom calendar data",
				"Refined and simplified the flow of message retrieval and event chains in a scheduling application",
				"Developed and tested new features for a robust financial calculation engine",
				"Contributed to a Java/Angular webapp for medical lab test ordering",
				"Conducted technical interviews for new associate consultant candidates"
			]
		},
		{
			company: "X-ES",
			title: "Associate Business App Developer",
			subTitle: "Extreme Engineering Solutions",
			link: {
				url: "https://www.xes-inc.com/about/",
				displayString: "Extreme Engineering Solutions"
			},
			icon: {
				path: "logos/xes-logo.png",
				alt: "Extreme Engineering Solutions",
				url: "https://www.xes-inc.com/about/"
			},
			dateRange: {
				startDate: new Date("2017-05-22"),
				endDate: new Date("2017-12-22")
			},
			location: "Middleton, Wisconsin",
			descriptionList: [
				"Investigated and established a web app testing pipeline and testing library with Jenkins and Selenium",
				"Created a suite of Perl scripts to validate product manufacturing info across database instances"
			]
		},
	]
}
